const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/companies/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/companies/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});